import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { FONT_SIZE_BIG } from '../../../constants';
import { crossScreenFontSize, toVw, toVwMobile, toVwTablet } from '../../../utils/styles';
import mq from '@/utils/media-queries';

const Title = styled.div`
  margin-bottom: ${toVw(22)};
  ${crossScreenFontSize(FONT_SIZE_BIG)};

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(22)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(22)};
  `)};
`;

const Text = styled.div``;

const Feature = ({ className, title, text }) => (
  <div className={className} data-test="feature">
    <Title>{title}</Title>
    <Text>{text}</Text>
  </div>
);

Feature.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default Feature;



// WEBPACK FOOTER //
// ./src/scenes/About/components/Feature.js